import { create } from "zustand";

export interface Tab {
  name: string;
  panels: string[];
  setVisible: (visible: boolean) => void;
  close: () => void;
}

type MinimizedState = {
  tabs: Tab[];
  setTabs: (tabs: Tab[]) => void;
  addTab: (tab: Tab) => void;
  restoreTab: (tabName: string) => void;
  deleteTab: (tabName: string) => void;
};

export const useMinimizedTabsStore = create<MinimizedState>((set, get) => ({
  tabs: [],
  setTabs: (tabs) =>
    set(() => {
      console.log("Minimized tabs updated: ", tabs);
      return { tabs: tabs };
    }),

  addTab: (tab: Tab) =>
    set(() => {
      const currentTabs = get().tabs;
      const updatedTabs = [...currentTabs, tab];
      console.log("Adding minimized tab: ", tab);
      return { tabs: updatedTabs };
    }),

  restoreTab: (tabName: string) => {
    // get the tab
    console.log("Removing minimized tab: ", tabName);
    
    const currentTabs = get().tabs;
    const targetTab = currentTabs.find((t) => t.name === tabName);

    // if found, make its panels visible
    if (targetTab) {
      targetTab.setVisible(true);
    }
    
    // remove the tab from the list
    const updatedTabs = currentTabs.filter((t) => t.name !== tabName);

    set(() => {
      return { tabs: updatedTabs };
    });
  },
  deleteTab: (tabName: string) => {
    console.log("Deleting minimized tab: ", tabName);
    const currentTabs = get().tabs;
    const updatedTabs = currentTabs.filter((t) => t.name !== tabName);
    set(() => {
      return { tabs: updatedTabs };
    });
  },
}));
